import { Injectable } from "@angular/core";
//import * as bootbox from "bootbox";
declare var bootbox: any;

@Injectable()
export class NotifyService {
    warning(message: string, callback?: any, title?: string) {
        return bootbox.dialog({
            title: title ? title : "Warning",
            message: message,
            closeButton: false,
            //className: "modal",
            buttons: {
                confirm: {
                    label: "Ok",
                    className: "btn-secondary",
                    callback: callback === null ? () => { } : callback
                }
            }
        });
    }

    info(message: string, callback?: any) {
        return bootbox.dialog({
            title: "Information",
            message: message,
            closeButton: false,
            //className: "modal fade show",
            buttons: {
                confirm: {
                    label: "Ok",
                    className: "btn-secondary",
                    callback: callback === null ? () => { } : callback
                }
            }
        });
    }

    success(message: string, callback?: any) {
        return bootbox.dialog({
            title: "Success",
            message: message,
            closeButton: false,
            //className: "modal fade show",
            buttons: {
                confirm: {
                    label: "Ok",
                    className: "btn-secondary",
                    callback: callback === null ? () => { } : callback
                }
            }
        });
    }

    error(message: string, callback?: any) {
        return bootbox.dialog({
            title: "Error",
            message: message,
            closeButton: false,
            //className: "modal fade show",
            buttons: {
                confirm: {
                    label: "Ok",
                    className: "btn-secondary",
                    callback: callback === null ? () => { } : callback
                }
            }
        });
    }

    defaultError() {
        return bootbox.dialog({
            title: "Server Error",
            message: "There is problem with the resource which you are looking for, and it can not be displayed.",
            closeButton: false,
            //className: "modal fade show",
            buttons: {
                confirm: {
                    label: "Close",
                    className: "btn-secondary"
                }
            }
        });
    }

    confirm(message: string, yesCallback?: any, noCallback?: any) {
        return bootbox.dialog({
            title: "Confirmation",
            message: message,
            closeButton: false,
            buttons: {
                confirm: {
                    label: "Yes",
                    className: "btn-secondary",
                    callback: yesCallback === null ? () => { } : yesCallback
                },
                cancel: {
                    label: "No",
                    className: "btn-secondary",
                    callback: noCallback === null ? () => { } : noCallback
                }
            }
        });
    }

    close() {
        bootbox.hideAll();
    }
}
